import type { JSX } from "preact";
import { Button } from "@gss/components/Button";
import { CheckAll } from "@gss/components/icons";
import { useTranslation } from "../util/Translation";

interface Props {
    onClick: () => void;
    className?: string;
    disabled?: boolean;
}

export function ButtonSelectAll({
    onClick,
    className,
    disabled,
}: Props): JSX.Element {
    const t = useTranslation().translation.filters;
    return (
        <Button
            variant="default"
            small
            className={className}
            disabled={disabled}
            onClick={onClick}
        >
            <CheckAll className="icon-check-all" aria-hidden /> {t.selectAll}
        </Button>
    );
}
